import { Row } from 'react-table';
import { TrailId } from '../../types/trails';
import { AlgoliaAlert } from '../../types/alerts';

type TrailAlerts = {
  trailId: TrailId;
  alerts: AlgoliaAlert[];
};

const getSelectedTrailIds = (selectedFlatRows: Array<Row>): Array<TrailId> => selectedFlatRows.map(row => row.values.checkbox);
const getSelectedTrailsAlerts = (selectedFlatRows: Array<Row>): Array<TrailAlerts> => {
  const selectedRowsWithAlerts = selectedFlatRows.filter(row => row.values.alerts.length > 0);
  return selectedRowsWithAlerts.map(row => ({ trailId: row.values.checkbox, alerts: row.values.alerts }));
};

export { getSelectedTrailIds, getSelectedTrailsAlerts };
